import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import styled from 'styled-components'
import { inject, observer } from 'mobx-react'
import { extendObservable } from 'mobx'
import { TweenMax } from 'gsap'
import UpArrowBlackIcon from '@/assets/images/preplay-up-arrow-black.webp'
import UpArrowWhiteIcon from '@/assets/images/preplay-up-arrow-white.webp'
import Star6Icon from '@/assets/images/preplay-sponsor-star6.svg'
import { vhToPx, hex2rgb } from '@/utils'
import '@/styles/sponsor-dropdown.css'
import SponsorItem from '@/Components/CommandHost/Common/SponsorItem'
import _ from 'lodash'

@inject(
  'PrePlayStore',
  'PlayStore',
  'GameStore',
  'CommandHostStore',
  'AutomationStore'
)
@observer
export default class DDAnnounceSponsor extends Component {
  constructor(props) {
    super(props)
    extendObservable(this, {
      selectedItem: null,
      sponsors:
        this.props.PrePlayStore.sponsors ||
        (props.prePlayStore && props.prePlayStore.sponsors),
      sportTypeNoHover: false,
    })
    this.reference = 'announce-sponsor-option-'

    this.dropdownSelectId = ''
    this.dropdownOptionId = ''
    this.dropdownSponsorCategory = ''
    this.dropdownSponsorItem = ''
    this.state = {
      selectPosition: {
        x: '',
        y: '',
        width: '',
      },
      showDropDown: false,
    }
  }

  getLocationFromSubType(subType) {
    if (!subType) return 'announce'
    const st = subType.toLowerCase()
    if (st.includes('gm_announce_msg')) return 'gm_mes_announcement'
    if (st.includes('gm_announce_video')) return 'mes_vid_announcement'
    if (st.includes('interrupt')) return 'interrupt_announcement'
    if (st.includes('time_period')) return 'time_period_announcement'
    if (st === 'msg') return 'announce'
    return 'announce'
  }

  initOptionEventListener(mode) {
    let func = evt => {
      const option = this[`${this.reference}${this.props.index}`]

      if (option) {
        let targetElement = evt.target // clicked element

        do {
          if (targetElement == option) {
            // This is a click inside. Do nothing, just return.
            return
          }
          // Go up the DOM
          targetElement = targetElement.parentNode
        } while (targetElement)

        // This is a click outside.
        // TweenMax.to(option, 0.3, { visibility: 'hidden' })
        document.removeEventListener('click', func)
        if (!this.selectedItem) {
          this.props.value(null)
        }
      }
    }

    if (mode === 0) {
      document.removeEventListener('click', func)
    } else {
      document.addEventListener('click', func)
    }
  }

  handleExpanded(expanded) {
    const option = this[`${this.reference}${this.props.index}`]

    if (expanded) {
      if (option) {
        setTimeout(() => {
          this.initOptionEventListener(1)
          option.className += ' open' //added 050312021
          TweenMax.to(option, 0.3, { visibility: 'visible' })
        }, 0)
      }
      const el = document.querySelector('.sponsor-btn-wrapper')
      const { left, top, width } = el.getBoundingClientRect()
      this.setState({
        showDropDown: expanded,
        selectPosition: {
          x: left,
          y: top,
          width,
        },
      })
    } else {
      if (option) {
        this.initOptionEventListener(0)
        option.className = option.className.replace(' open', '') //added 050312021
        // TweenMax.to(option, 0.3, { visibility: 'hidden' })
      }
    }
  }

  handleOptionItemClick(val, refId, strToReplace, optionItem) {
    const option = this[`${this.reference}${this.props.index}`]
    if (option) {
      if (option.classList.contains('open')) {
        this.initOptionEventListener(0)
        option.className = option.className.replace(' open', '')
        // TweenMax.to(option, 0.3, { visibility: 'hidden', zIndex: -1000 })
      }

      this.selectedItem = val
      this.props.value(val, optionItem, refId, strToReplace)
    }
  }

  handleUndoManualOverride(refId) {
    const option = this[`${this.reference}${this.props.index}`]
    if (option) {
      if ((option.classList || []).contains('open')) {
        this.initOptionEventListener(0)
        option.className = (option.className || '').replace(' open', '')
      }
    }

    this.toggleSponsorOpenClose()
    this.setState({ showDropDown: false })
    this.selectedItem = null

    this.props.value(null, 'Undo', refId, 'Undo')
  }

  handleSponsorItemClick(cat, brand, refId) {
    // if (this.props.automationAddEvent) {
    //   this.props.automationAddEvent({
    //     evt: 'click',
    //     refId: refId,
    //     wait: 0.5,
    //     isIncrementHeaderPlaySequence: refId.includes('header'),
    //   })
    // }

    this.toggleSponsorOpenClose()
    this.setState({ showDropDown: false })
    this.selectedItem = { sponsorCategory: cat, sponsorItem: brand }
    this.props.value({ sponsorCategory: cat, sponsorItem: brand })

    /**
     * COMMENT THIS
     * IF YOU DON'T WANT TO USE HOVER
     */
    this.sportTypeNoHover = true
    setTimeout(() => (this.sportTypeNoHover = false), 500)
  }

  toggleSponsorOpenClose() {
    const option = this[`${this.reference}${this.props.index}`]
    if (option) {
      if (option.classList.contains('open')) {
        this.initOptionEventListener(0)
        option.className = option.className.replace(' open', '')
        // TweenMax.to(option, 0.3, { visibility: 'hidden' })
      } else {
        setTimeout(() => {
          this.initOptionEventListener(1)
          option.className += ' open'
          TweenMax.to(option, 0.3, { visibility: 'visible' })
        }, 0)
      }
    }
  }

  handleSponsorBrandClick(refId, event) {
    if (this.props.automationAddEvent) {
      this.props.automationAddEvent({
        evt: 'click',
        refId: refId,
        wait: 0.5,
        isIncrementHeaderPlaySequence: refId.includes('header'),
      })
    }

    const clickedElement = event.currentTarget
    const { left, top, width } =
      (clickedElement && clickedElement.getBoundingClientRect()) || {}

    this.setState(
      {
        showDropDown: true,
        selectPosition: {
          x: left,
          y: top,
          width,
        },
      },
      this.toggleSponsorOpenClose
    )

    // this.toggleSponsorOpenClose()

    /**
     * UNCOMMENT THIS
     * IF YOU DON'T WANT TO USE HOVER

     for (let i=0; i<this.sponsors.length; i++) {
      this[`refSponsorCategory-${i}`].querySelector('ul').style.display = 'none'
    }
     **/
  }

  resolveSelectedItem(props = this.props) {
    const sponsors =
      (props.PrePlayStore && props.PrePlayStore.sponsors) ||
      (this.props.PrePlayStore && this.props.PrePlayStore.sponsors) ||
      this.sponsors ||
      []
    this.sponsors = sponsors

    if (
      props.selectedSponsor &&
      Object.values(props.selectedSponsor).every(Boolean)
    ) {
      return props.selectedSponsor
    }

    let pmeta = props.pmetadata
    if (typeof pmeta === 'string') {
      try {
        pmeta = JSON.parse(pmeta)
      } catch (e) {
        pmeta = null
      }
    }
    const pmetaPublic = pmeta && pmeta.public ? pmeta.public : pmeta

    const effectiveSponsorId =
      props.sponsorId ||
      (pmetaPublic &&
        (pmetaPublic.sponsorId ||
          pmetaPublic.resolvedSponsorId ||
          pmetaPublic.resolvedBrandId)) ||
      (props.sponsorMetaData && props.sponsorMetaData.brandId) ||
      (props.selectedSponsor &&
        props.selectedSponsor.sponsorItem &&
        props.selectedSponsor.sponsorItem.brandId) ||
      0

    if (effectiveSponsorId) {
      const subBrandText =
        (props.sponsorMetaData &&
          (props.sponsorMetaData.placement_subbrand_text ||
            props.sponsorMetaData.selectedSubbrand)) ||
        (pmetaPublic && pmetaPublic.placement_subbrand_text) ||
        null

      const assetSetId =
        (props.sponsorMetaData && props.sponsorMetaData.assetSetId) ||
        (pmetaPublic &&
          (pmetaPublic.resolvedAssetSetId || pmetaPublic.assetSetId)) ||
        null

      const found = sponsors.reduce((selected, category) => {
        const sponsorItem = category.brands.find(
          c => c.brandId === effectiveSponsorId
        )
        if (sponsorItem) {
          let matchedSubbrand = null
          if (sponsorItem.subbrands && sponsorItem.subbrands.length > 0) {
            if (assetSetId) {
              matchedSubbrand = sponsorItem.subbrands.find(
                sb => String(sb.assetSetId) === String(assetSetId)
              )
            }
            if (!matchedSubbrand && subBrandText) {
              matchedSubbrand = sponsorItem.subbrands.find(
                sb => sb.text === subBrandText
              )
            }
          }
          const enhancedSponsorItem = {
            ...sponsorItem,
            selectedSubbrand: matchedSubbrand
              ? matchedSubbrand.text
              : subBrandText || sponsorItem.selectedSubbrand,
            assetSetId: matchedSubbrand
              ? matchedSubbrand.assetSetId
              : assetSetId || sponsorItem.assetSetId,
            placement_subbrand_text: matchedSubbrand
              ? matchedSubbrand.text
              : subBrandText || sponsorItem.placement_subbrand_text,
          }
          return {
            sponsorCategory: category,
            sponsorItem: enhancedSponsorItem,
          }
        }
        return selected
      }, null)

      if (found) {
        return found
      }
    }

    const noBrandAsset =
      props.GameStore && props.GameStore.brandAssets
        ? _.find(props.GameStore.brandAssets, { code: 'nobrand' })
        : null

    if (noBrandAsset && effectiveSponsorId === noBrandAsset.brandId) {
      return {
        sponsorCategory: null,
        sponsorItem: noBrandAsset,
      }
    }

    return null
  }

  componentWillReceiveProps(nextProps) {
    this.handleExpanded(nextProps.expanded)
    this.selectedItem = this.resolveSelectedItem(nextProps)
  }

  async componentWillMount() {
    this.sponsors = this.props.PrePlayStore.sponsors
    this.selectedItem = this.resolveSelectedItem(this.props)
  }

  componentDidMount() {
    let { item } = this.props
    if (item) {
      if (item.type) {
        if (item.id) {
          this.dropdownSelectId = `dropdown-sponsor-select-${item.type}-${item.id}`
        } else {
          this.dropdownSelectId = `dropdown-sponsor-select-${item.type}-${this.props.AutomationStore.playSequence}`
        }
      } else {
        this.dropdownSelectId = `dropdown-sponsor-select-${this.props.AutomationStore.playSequence}`
      }
    } else {
      this.dropdownSelectId = `header-dropdown-sponsor-select-${this.props.AutomationStore.headerPlaySequence}`
    }
    this.noBrandAsset = _.find(this.props.GameStore.brandAssets, {
      code: 'nobrand',
    })
    if (
      this.noBrandAsset &&
      this.props.sponsorId &&
      this.props.sponsorId === this.noBrandAsset.brandId
    ) {
      this.selectedItem = {
        sponsorCategory: null,
        sponsorItem: this.noBrandAsset,
      }
    }
  }

  render() {
    let {
      locked,
      forId,
      item,
      playStackItem,
      announceItemOnPlayStack,
      playStackFromUnresolved,
      GameStore,
      type,
      isAnnouncementAfterActive,
    } = this.props

    const optionIdNone = `${forId}-brand-option-0`
    const optionIdNoBrand = `${forId}-brand-option-1`

    let pmetaObj = this.props.pmetadata
    if (typeof pmetaObj === 'string') {
      try {
        pmetaObj = JSON.parse(pmetaObj)
      } catch (e) {
        pmetaObj = null
      }
    }
    const hasManualOverride =
      (pmetaObj &&
        (pmetaObj.isManualOverride === true ||
          (pmetaObj.public && pmetaObj.public.isManualOverride === true))) ||
      false

    const PlayStackItemStyle = {
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'bottom -0.4vh right',
      backgroundSize: '1.4vh',
      backgroundImage: 'url(/static/media/preplay-up-arrow-black.86e9a30f.svg)',
      paddinggLeft:
        this.selectedItem && this.selectedItem.sponsorItem ? '0.5vh' : '',
    }
    const { noBrandAsset } = this
    const fromStack =
      this.props.fromStack ||
      (this.props.announceItemOnPlayStack
        ? 'Anc_item'
        : this.props.playStackItem
        ? 'PLAY_ITEM'
        : '')
    const AnnounceSelect = () => {
      const { x, y, width } = this.state.selectPosition
      const standardWidthPx = (17 * window.innerHeight) / 100
      const effectiveWidth = Math.max(width || 0, standardWidthPx)
      const effectiveX =
        typeof x === 'number'
          ? Math.min(x, window.innerWidth - effectiveWidth - 10)
          : x
      const sponsorsList =
        this.props.PrePlayStore.sponsors ||
        (this.props.prePlayStore && this.props.prePlayStore.sponsors) ||
        []
      const dropDownHeightVH = (sponsorsList.length + 3) * 6
      const position =
        y + (window.innerHeight * dropDownHeightVH) / 100 > window.innerHeight
          ? 'top'
          : 'bottom'
      const isNewAnc = ['Anc_item'].includes(fromStack)

      return (
        <OptionWrapperContainer
          style={{
            zIndex: 99999,
          }}
          onClick={() => {
            this.setState({
              showDropDown: false,
            })
          }}
        >
          <OptionWrapper
            style={{
              ...(position === 'bottom' && {
                top: `calc(${isNewAnc ? 5 : 6}vh + ${y}px)`,
              }),
              ...(position === 'top' && {
                bottom: `${window.innerHeight - y}px`,
              }),
              left: effectiveX,
              width: effectiveWidth,
              zIndex: 100000,
            }}
          >
            <Option>
              <OptionItems
                innerRef={ref =>
                  (this[`${this.reference}${this.props.index}`] = ref)
                }
              >
                <nav>
                  <ul name="packages">
                    <li>
                      <OptionItem
                        id={optionIdNone}
                        key={-2}
                        onClick={this.handleOptionItemClick.bind(
                          this,
                          null,
                          optionIdNone,
                          '-brand-option-0',
                          'Default'
                        )}
                      >
                        <Item
                          style={{
                            fontFamily: 'pamainbold',
                            fontSize: '1.8vh',
                            justifyContent: 'center',
                          }}
                          height={this.props.height}
                        >
                          {'DEFAULT'}
                        </Item>
                      </OptionItem>
                      {hasManualOverride && !this.props.hideUndo && (
                        <OptionItem
                          id={`${forId}-brand-option-undo`}
                          key={-3}
                          onClick={this.handleUndoManualOverride.bind(
                            this,
                            `${forId}-brand-option-undo`
                          )}
                        >
                          <Item
                            style={{
                              fontFamily: 'pamainbold',
                              fontSize: '1.8vh',
                              justifyContent: 'center',
                              color: '#ffffff',
                              backgroundColor: '#c61818',
                            }}
                            height={this.props.height}
                          >
                            {'UNDO MANUAL OVERRIDE'}
                          </Item>
                        </OptionItem>
                      )}
                      {noBrandAsset && (
                        <OptionItem
                          id={optionIdNoBrand}
                          key={-1}
                          onClick={this.handleSponsorItemClick.bind(
                            this,
                            null,
                            noBrandAsset,
                            `${this.dropdownSponsorItem}-${noBrandAsset.brandId}`
                          )}
                        >
                          <Item
                            style={{
                              fontFamily: 'pamainbold',
                              fontSize: '1.8vh',
                              justifyContent: 'center',
                            }}
                            height={this.props.height}
                            color={'#fff'}
                            backgroundColor={'#000'}
                          >
                            {noBrandAsset.name || 'NO BRAND'}
                          </Item>
                        </OptionItem>
                      )}
                    </li>
                    {sponsorsList.map((cat, idx) => {
                      const optionId = `${forId}-brand-option-${cat.id}`
                      if (item) {
                        if (item.type) {
                          if (item.id) {
                            this.dropdownOptionId = `dropdown-sponsor-option-${item.type}-${item.id}-${cat.id}`
                            this.dropdownSponsorCategory = `dropdown-sponsor-category-${item.type}-${item.id}-${cat.id}`
                            this.dropdownSponsorItem = `dropdown-sponsor-item-${item.type}-${item.id}-${cat.id}`
                          } else {
                            this.dropdownOptionId = `dropdown-sponsor-option-${item.type}-${this.props.AutomationStore.playSequence}-${cat.id}`
                            this.dropdownSponsorCategory = `dropdown-sponsor-category-${item.type}-${this.props.AutomationStore.playSequence}-${cat.id}`
                            this.dropdownSponsorItem = `dropdown-sponsor-item-${item.type}-${this.props.AutomationStore.playSequence}-${cat.id}`
                          }
                        } else {
                          this.dropdownOptionId = `dropdown-sponsor-option-${this.props.AutomationStore.playSequence}-${cat.id}`
                          this.dropdownSponsorCategory = `dropdown-sponsor-category-${this.props.AutomationStore.playSequence}-${cat.id}`
                          this.dropdownSponsorItem = `dropdown-sponsor-item-${this.props.AutomationStore.playSequence}-${cat.id}`
                        }
                      } else {
                        this.dropdownOptionId = `header-dropdown-sponsor-option-${this.props.AutomationStore.headerPlaySequence}-${cat.id}`
                        this.dropdownSponsorCategory = `dropdown-sponsor-category-${this.props.AutomationStore.headerPlaySequence}-${cat.id}`
                        this.dropdownSponsorItem = `dropdown-sponsor-item-${this.props.AutomationStore.headerPlaySequence}-${cat.id}`
                      }
                      const topPosition =
                        (idx +
                          (!['PLAY_ITEM', 'Anc_item'].includes(fromStack) &&
                          position === 'bottom'
                            ? 3
                            : 1)) *
                        this.props.height

                      const beforeCategoriesCount =
                        1 +
                        (hasManualOverride && !this.props.hideUndo ? 1 : 0) +
                        (noBrandAsset ? 1 : 0)
                      const actualVisualTopPosition = [
                        'PLAY_ITEM',
                        'Anc_item',
                      ].includes(fromStack)
                        ? topPosition
                        : (beforeCategoriesCount + idx) * this.props.height

                      let maxHeight =
                        window.innerHeight -
                        ((topPosition + 7) * window.innerHeight) / 100 -
                        y

                      if (position === 'top') {
                        maxHeight =
                          maxHeight +
                          ((sponsorsList.length - idx + 1 + 1) *
                            6 *
                            window.innerHeight) /
                            100
                      }

                      let visualBrandIndex = 0
                      return (
                        <li
                          key={`li-sponsor-category-announce-${idx}`}
                          ref={ref =>
                            (this[`refSponsorCategoryAnnounce-${idx}`] = ref)
                          }
                          className={this.sportTypeNoHover ? 'nohover' : ''}
                          style={{ position: 'relative' }}
                        >
                          <OptionItem
                            id={this.dropdownOptionId}
                            // onClick={this.handleOptionItemClick.bind(
                            //   this,
                            //   cat,
                            //   optionId,
                            //   `-brand-option-${cat.id}`
                            // )}
                          >
                            <Item
                              height={this.props.height}
                              text={cat.name}
                              backgroundColor={cat.backgroundColor}
                            >
                              <ItemInner>
                                <ItemName
                                  style={{
                                    marginRight: '1.5vh',
                                  }}
                                >
                                  {cat.name}
                                </ItemName>
                                <CircleWrapper>
                                  <ItemOuterBorderCircle
                                    borderColor={cat.circleBorderColor}
                                    circleFill={cat.circleFill}
                                    color={cat.initialColor}
                                    text={cat.initial}
                                    height={this.props.height}
                                    playStackItem={playStackItem}
                                  />
                                </CircleWrapper>
                                {/* <CountWrapper>
                                  <Count>{cat.count}</Count>
                                </CountWrapper> */}
                              </ItemInner>
                            </Item>
                          </OptionItem>

                          <ul
                            ref={ref => (this[`refSponsortItems-${idx}`] = ref)}
                            name="brands"
                            className="sponsoritemsul"
                            style={{
                              position: 'absolute',
                              maxHeight: maxHeight,
                              overflow: 'visible',
                              ...(['PLAY_ITEM', 'Anc_item'].includes(
                                fromStack
                              ) && {
                                right: '100%',
                                top: 0,
                                maxHeight: maxHeight,
                              }),
                            }}
                          >
                            {(cat.brands || []).map((brand, idx) => {
                              let actualType =
                                type === 'Announcements'
                                  ? 'announce_item'
                                  : type === 'sponsor'
                                  ? 'sponsor_play'
                                  : type

                              let placement = this.props.pmetadata
                                ? this.props.pmetadata.placement ||
                                  (this.props.pmetadata.public
                                    ? this.props.pmetadata.public.placement ||
                                      ''
                                    : '')
                                : ''
                              let moment = this.props.pmetadata
                                ? this.props.pmetadata.moment ||
                                  (this.props.pmetadata.public
                                    ? this.props.pmetadata.public.moment || ''
                                    : '')
                                : ''

                              if (!placement && !moment) {
                                const gm =
                                  this.props.gameMoment ||
                                  (this.props.item &&
                                    (this.props.item.game_moment ||
                                      (this.props.item.preset &&
                                        this.props.item.preset.game_moment))) ||
                                  (this.props.pmetadata &&
                                    this.props.pmetadata.game_moment)
                                if (gm) {
                                  const parts = String(gm).split('|')
                                  placement = parts.length > 1 ? parts[0] : ''
                                  moment = parts.length > 1 ? parts[1] : gm
                                }
                              }

                              const isBrandAvailable = GameStore.isBrandAvailable(
                                brand.brandId,
                                actualType,
                                placement,
                                moment,
                                brand.brandName
                              )
                              // console.log(`Render Brand ${brand.brandName} (${brand.brandId}) in package ${cat.name}? isAvailable=${isBrandAvailable}`);
                              if (brand && brand.brandId && isBrandAvailable) {
                                const _cat = { ...cat }
                                delete _cat.brands
                                const brandHeightPx =
                                  (this.props.height * window.innerHeight) / 100
                                const brandTopPx =
                                  position === 'bottom'
                                    ? y +
                                      (((isNewAnc ? 5 : 6) +
                                        actualVisualTopPosition +
                                        visualBrandIndex * this.props.height) *
                                        window.innerHeight) /
                                        100
                                    : y -
                                      (dropDownHeightVH * window.innerHeight) /
                                        100 +
                                      ((actualVisualTopPosition +
                                        visualBrandIndex * this.props.height) *
                                        window.innerHeight) /
                                        100

                                const filteredSubbrands = (
                                  brand.subbrands || []
                                ).filter(sbObj => {
                                  if (
                                    GameStore &&
                                    GameStore.isSubBrandAvailable
                                  ) {
                                    return GameStore.isSubBrandAvailable(
                                      brand.brandId,
                                      sbObj,
                                      actualType,
                                      placement,
                                      moment
                                    )
                                  }
                                  return true
                                })

                                const headerHeightPx =
                                  (5.5 * window.innerHeight) / 100
                                const spaceDown = Math.max(
                                  0,
                                  window.innerHeight - brandTopPx - 15
                                )
                                const spaceUp = Math.max(
                                  0,
                                  brandTopPx +
                                    brandHeightPx -
                                    headerHeightPx -
                                    10
                                )
                                const contentHeightPx =
                                  (filteredSubbrands
                                    ? filteredSubbrands.length
                                    : 0) * brandHeightPx

                                let subPosition = 'bottom'
                                if (
                                  contentHeightPx > spaceDown &&
                                  spaceUp > spaceDown
                                ) {
                                  subPosition = 'top'
                                }

                                const subMaxHeight =
                                  subPosition === 'top'
                                    ? spaceUp + 'px'
                                    : spaceDown + 'px'

                                visualBrandIndex++
                                console.log(
                                  `[SZ SPORTS DEBUG] y:${y} vbi:${visualBrandIndex -
                                    1} idx:${idx} avtp:${actualVisualTopPosition} btp:${brandTopPx} sD:${spaceDown} sU:${spaceUp} ch:${contentHeightPx} pos:${subPosition}`
                                )
                                return (
                                  <li
                                    key={`li-sponsor-brand-${this.dropdownSponsorItem}-${brand.brandId}`}
                                    style={{
                                      height: this.props.height + 'vh',
                                      position: 'relative',
                                      zIndex: 10000,
                                      boxShadow:
                                        'rgba(0, 0, 0, 1) 0px 5px 15px',
                                    }}
                                  >
                                    <div
                                      style={{ width: '100%', height: '100%' }}
                                    >
                                      <SponsorItem
                                        hasBorderBottom={
                                          idx < cat.brands.length - 1
                                            ? true
                                            : false
                                        }
                                        item={brand}
                                        backgroundColor={_cat.backgroundColor}
                                        id={`${this.dropdownSponsorItem}-${brand.brandId}`}
                                        refClick={this.handleSponsorItemClick.bind(
                                          this,
                                          _cat,
                                          brand,
                                          `${this.dropdownSponsorItem}-${brand.brandId}`
                                        )}
                                        isAnnouncementAfterActive={
                                          isAnnouncementAfterActive
                                        }
                                      />
                                    </div>
                                    {filteredSubbrands &&
                                      filteredSubbrands.length > 0 && (
                                        <ul
                                          name="subbrands"
                                          className="subbranditemsul"
                                          style={{
                                            position: 'absolute',
                                            right: '100%',
                                            left: 'auto',
                                            top:
                                              subPosition === 'top'
                                                ? 'auto'
                                                : 0,
                                            bottom:
                                              subPosition === 'top'
                                                ? 0
                                                : 'auto',
                                            maxHeight: subMaxHeight,
                                            overflowY: 'auto',
                                            margin: 0,
                                            padding: 0,
                                            listStyle: 'none',
                                            backgroundColor:
                                              _cat.backgroundColor,
                                          }}
                                        >
                                          {filteredSubbrands.map(
                                            (sbObj, sbIdx) => {
                                              return (
                                                <li
                                                  key={`sb-${sbIdx}`}
                                                  style={{
                                                    width: '100%',
                                                    height:
                                                      this.props.height + 'vh',
                                                    position: 'relative',
                                                    zIndex: 10001,
                                                    boxShadow:
                                                      'rgba(0, 0, 0, 1) 0px 5px 15px',
                                                  }}
                                                >
                                                  <div
                                                    style={{
                                                      width: '100%',
                                                      height: '100%',
                                                    }}
                                                  >
                                                    <SponsorItem
                                                      hasBorderBottom={
                                                        sbIdx <
                                                        filteredSubbrands.length -
                                                          1
                                                          ? true
                                                          : false
                                                      }
                                                      item={{
                                                        brandName: sbObj.text,
                                                      }}
                                                      hideIcon={true}
                                                      backgroundColor={
                                                        _cat.backgroundColor
                                                      }
                                                      id={`${this.dropdownSponsorItem}-${brand.brandId}-sb-${sbIdx}`}
                                                      refClick={e => {
                                                        e.stopPropagation()
                                                        const matchedAsset =
                                                          GameStore &&
                                                          GameStore.getMatchingAssetSetForSubBrand
                                                            ? GameStore.getMatchingAssetSetForSubBrand(
                                                                brand.brandId,
                                                                sbObj,
                                                                actualType,
                                                                placement,
                                                                moment
                                                              )
                                                            : null
                                                        const effectiveAssetSetId = matchedAsset
                                                          ? matchedAsset.assetSetId
                                                          : sbObj.assetSetId
                                                        const updatedBrand = {
                                                          ...brand,
                                                          selectedSubbrand:
                                                            sbObj.text,
                                                          assetSetId: effectiveAssetSetId,
                                                          placement_subbrand_text:
                                                            sbObj.text,
                                                        }
                                                        this.handleSponsorItemClick(
                                                          _cat,
                                                          updatedBrand,
                                                          `${this.dropdownSponsorItem}-${brand.brandId}-sb-${sbIdx}`
                                                        )
                                                      }}
                                                      isAnnouncementAfterActive={
                                                        isAnnouncementAfterActive
                                                      }
                                                    />
                                                  </div>
                                                </li>
                                              )
                                            }
                                          )}
                                        </ul>
                                      )}
                                  </li>
                                )
                              } else {
                                return null
                              }
                            })}
                          </ul>
                        </li>
                      )
                    })}
                  </ul>
                </nav>
                {/*
            <OptionItem
              id={optionIdNone}
              key={-1}
              onClick={this.handleOptionItemClick.bind(
                this,
                null,
                optionIdNone,
                '-brand-option-0'
              )}
            >
              <Item height={this.props.height}>NONE</Item>
            </OptionItem>
            {this.sponsors.map((val, idx) => {
              const optionId = `${forId}-brand-option-${val.id}`
              return (
                <OptionItem
                  id={optionId}
                  key={idx}
                  onClick={this.handleOptionItemClick.bind(
                    this,
                    val,
                    optionId,
                    `-brand-option-${val.id}`
                  )}
                >
                  <Item
                    height={this.props.height}
                    text={val.name}
                    backgroundColor={val.backgroundColor}
                  >
                    <ItemName>{val.name}</ItemName>
                    <CircleWrapper>
                      <ItemOuterBorderCircle
                        borderColor={val.circleBorderColor}
                        circleFill={val.circleFill}
                        color={val.initialColor}
                        text={val.initial}
                        height={this.props.height}
                      />
                    </CircleWrapper>
                    <CountWrapper>
                      <Count>{val.count}</Count>
                    </CountWrapper>
                  </Item>
                </OptionItem>
              )
            })}
*/}
              </OptionItems>
            </Option>
          </OptionWrapper>
        </OptionWrapperContainer>
      )
    }
    const selectedItem =
      this.selectedItem || this.resolveSelectedItem(this.props)
    const isNoBrand =
      selectedItem &&
      selectedItem.sponsorItem &&
      (selectedItem.sponsorItem.name || '')
    const isGMAnnounce =
      (this.props.subType && this.props.subType.includes('gm_announce')) ||
      (this.props.type && this.props.type.includes('gm_announce'))
    return (
      <Scrolling
        style={
          playStackItem || announceItemOnPlayStack ? PlayStackItemStyle : null
        }
      >
        <div className="sponsor-btn-wrapper">
          {!selectedItem || isNoBrand ? (
            <Button
              locked={locked}
              height={this.props.height}
              onClick={
                locked
                  ? null
                  : this.handleSponsorBrandClick.bind(
                      this,
                      this.dropdownSelectId
                    )
              }
              backgroundColor={isNoBrand && '#000'}
              style={announceItemOnPlayStack ? PlayStackItemStyle : null}
            >
              <div
                style={{
                  width: playStackItem
                    ? isGMAnnounce
                      ? 'auto'
                      : '17vh'
                    : '100%',
                }}
              >
                <ItemName
                  style={{
                    paddingLeft: '1vh',
                    paddingRight: isGMAnnounce ? '1vh' : 0,
                    whiteSpace: isGMAnnounce ? 'nowrap' : 'inherit',
                    ...(this.props.playStackFromUnresolved && {
                      justifyContent: 'center',
                      paddingLeft: 0,
                    }),
                  }}
                  color={isNoBrand ? '#fff' : '#000'}
                >
                  {!selectedItem ? 'DEFAULT' : selectedItem.sponsorItem.name}
                </ItemName>
              </div>
            </Button>
          ) : selectedItem.sponsorItem ? (
            <Button
              locked={locked}
              height={this.props.height}
              backgroundColor={
                selectedItem.sponsorCategory
                  ? selectedItem.sponsorCategory.backgroundColor
                  : '#000'
              }
              onClick={
                locked
                  ? null
                  : this.handleSponsorBrandClick.bind(
                      this,
                      this.dropdownSelectId
                    )
              }
              justifyContent="flex-start"
              style={{
                ...(announceItemOnPlayStack ? PlayStackItemStyle : {}),
                ...(this.props.playStackFromUnresolved && { paddingLeft: 0 }),
              }}
            >
              <div
                style={{
                  width: playStackItem
                    ? isGMAnnounce
                      ? 'auto'
                      : '17vh'
                    : '100%',
                }}
              >
                <ItemInner
                  style={{
                    paddingLeft: 0,
                  }}
                >
                  <SponsorItem
                    locked={locked}
                    hasBorderBottom={false}
                    item={selectedItem.sponsorItem}
                    backgroundColor={
                      selectedItem.sponsorCategory
                        ? selectedItem.sponsorCategory.backgroundColor
                        : '#000'
                    }
                    playStackItem={this.props.playStackItem}
                    playStackFromUnresolved={this.props.playStackFromUnresolved}
                    isAnnouncementAfterActive={isAnnouncementAfterActive}
                    subBrandText={
                      (selectedItem &&
                        selectedItem.sponsorItem &&
                        (selectedItem.sponsorItem.placement_subbrand_text ||
                          selectedItem.sponsorItem.selectedSubbrand)) ||
                      (this.props.sponsorMetaData &&
                        (this.props.sponsorMetaData.placement_subbrand_text ||
                          this.props.sponsorMetaData.selectedSubbrand)) ||
                      (this.props.pmetadata &&
                        this.props.pmetadata.placement_subbrand_text) ||
                      null
                    }
                  />
                </ItemInner>
              </div>
            </Button>
          ) : null}
        </div>

        {this.state.showDropDown &&
          ReactDOM.createPortal(<AnnounceSelect />, document.body)}
      </Scrolling>
    )
  }
}

const FONT_SIZE = '1.8vh'

const Scrolling = styled.div`
  display: flex;
  flex-direction: column;
  background-color: #ffffff;
`

const Button = styled.div`
  width: inherit;
  height: ${props => props.height}vh;
  font-family: pamainbold;
  font-size: ${props => FONT_SIZE};
  text-transform: uppercase;
  color: black;
  background-color: ${props => props.backgroundColor || ''};
  display: flex;
  flex-direction: row;
  align-items: center;
  ${props =>
    props.justifyContent ? `justify-content:${props.justifyContent}` : ''};
`

const EmptyBrandCircle = styled.div`
  width: 30%;
  display: flex;
  justify-content: center;
  align-items: center;
  &:after {
    content: '';
    display: inline-block;
    width: ${props => 4}vh;
    height: ${props => 4}vh;
    border-radius: 50%;
    background-color: #000000;
  }
`
const EmptyBrandCount = styled.div`
  width: 25%;
  font-family: pamainbold;
  font-size: ${props => 2}vh;
  color: #000000;
  display: flex;
  justify-content: center;
  align-items: center;
`
const Option = styled.div`
  width: inherit;
`
const OptionItems = styled.div`
  width: inherit;
  display: flex;
  flex-direction: column;
  background-color: #ffffff;
  z-index: 1500 !important;
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
`
const OptionItem = styled.div`
  width: 100%;
  height: ${props => props.height}vh;
  min-height: ${props => props.height}vh;
  z-index: 1500 !important;
  position: relative; /* added. so that all brands will appear on hover */
`

const Item = styled.div`
/*
  width: inherit;
  height: ${props => props.height}vh;
  font-family: pamainbold;
  font-size: ${props => FONT_SIZE};
  text-transform: uppercase;
  color: black;
  background-color: ${props => props.backgroundColor};
  display: flex;
  flex-direction: row;
  align-items: center;
  padding-left: ${props => 1.5}vh;
  &:hover {
    opacity: 0.7;
  }
*/

  width: inherit;
  height: ${props => props.height}vh;
  background-color: ${props => props.backgroundColor || '#ffffff'};
  display: flex;
  align-items: center;
  &:hover {
    background-color: ${props =>
      props.backgroundColor ? hex2rgb(props.backgroundColor, 0.5) : '#ffffff'};
  }
  color: ${props => props.color || '#000'};
  text-transform: uppercase;
`

const ItemInner = styled.div`
  height: ${props => props.height || '100%'};
  width: 100%;
  font-family: pamainbold;
  font-size: ${props => FONT_SIZE};
  text-transform: uppercase;
  color: black;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`

const ItemName = styled.div`
  height: inherit;
  display: flex;
  flex-direction: row;
  align-items: center;
  color: ${props => props.color || '#000'};
`

const CircleWrapper = styled.div``
const ItemOuterBorderCircle = styled.div`
  width: ${props => 4.3}vh;
  height: ${props => 4.3}vh;
  border-radius: 50%;
  border: ${props => 0.3}vh solid #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
  &:before {
    content: '';
    display: inline-block;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    border: ${props => 0.3}vh solid ${props => props.borderColor};
    background-color: ${props => props.circleFill};
/*
    background-image: url(${Star6Icon});
    background-repeat: no-repeat;
    background-position: center;
    background-size: 100%;
*/
  }

  &:after {
    position: absolute;
    content: '${props => props.text}';
    font-family: pamainbold;
    font-size: ${props => 0.6 * props.height}vh;
    text-transform: uppercase;
    color: ${props => props.color};
    padding-top: ${props => 0.2}vh;
  }
`

const CountWrapper = styled.div`
  width: 25%;
  height: inherit;
  display: flex;
  justify-content: center;
  align-items: center;
`
const Count = styled.div`
  font-family: pamainregular;
  font-size: ${props => 2}vh;
  color: #000000;
  font-weight: bold;
`
const OptionWrapperContainer = styled.div`
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: transparent;
  overflow: auto;
`

const OptionWrapper = styled.div`
  position: fixed;
  minwidth: 400;
`



// WEBPACK FOOTER //
// src/Components/CommandHost/Common/DDAnnounceSponsor.js